"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
require("./App.css");
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const App = () => {
    const [formData, setFormData] = (0, react_1.useState)({
        name: '',
        address: '',
        address2: '',
        city: '',
        postCode: '',
        phoneNo: '',
        email: '',
        bankAccountNumber: '',
        bankBranchNo: '',
        iban: '',
        companyRegistrationNo: '',
        vatRegistrationNo: '',
        swiftCode: '',
        datetimeSubmitted: '',
        paymentMethod: '',
        paymentTerms: '',
        files: []
    });
    const [id, setId] = (0, react_1.useState)('');
    const [companyId, setCompanyId] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)('');
    const [message, setMessage] = (0, react_1.useState)('');
    const [submitButton, setSubmitButton] = (0, react_1.useState)({ label: 'Submit', disabled: true, class: 'submit-button' });
    const [status, setStatus] = (0, react_1.useState)('');
    const [headerTitle, setHeaderTitle] = (0, react_1.useState)('');
    const [headerColour, setHeaderColour] = (0, react_1.useState)('#fff');
    const [htmlTop, setHtmlTop] = (0, react_1.useState)('');
    const [htmlBottom, setHtmlBottom] = (0, react_1.useState)('');
    const [paymentMethods, setPaymentMethods] = (0, react_1.useState)([]);
    const [paymentTerms, setPaymentTerms] = (0, react_1.useState)([]);
    document.title = headerTitle;
    //read the id and company id from the query string when the component mounts
    (0, react_1.useEffect)(() => {
        //read the id and company id (c) from the query string
        const queryParams = new URLSearchParams(window.location.search);
        setId(queryParams.get('id'));
        setCompanyId(queryParams.get('c'));
    }, []);
    //update the disabled state when the form data changes
    (0, react_1.useEffect)(() => {
        if (error === '') {
            setSubmitButton({ label: 'Submit', disabled: false, class: 'submit-button' });
        }
        else {
            setSubmitButton({ label: 'Submit', disabled: true, class: 'submit-button' });
        }
    }, [formData, error]);
    (0, react_1.useEffect)(() => {
        if (status === 'New') {
            setError('');
        }
        else if (status !== '') {
            setError(`This registration has already been submitted.`);
        }
    }, [status]);
    function updateError(message) {
        if (message !== '') {
            setError(message);
        }
        else {
            if (status !== 'New') {
                setError(`This registration has already been submitted.`);
            }
            else {
                setError('');
            }
        }
    }
    //fetch portal interaction details from the api
    (0, react_1.useEffect)(() => {
        if (id === '' || companyId === '') {
            return;
        }
        if (companyId) {
            fetch(`/api/getPortalSetup?c=${companyId}`).then((response) => __awaiter(void 0, void 0, void 0, function* () {
                if (response.ok) {
                    const portalSetups = yield response.json();
                    const portalSetup = portalSetups.value[0];
                    setHeaderTitle(portalSetup.pageTitle || 'New Supplier Registration');
                    setHeaderColour(portalSetup.headerColour || '#6e9297');
                    setHtmlTop(portalSetup.htmlTop || '');
                    setHtmlBottom(portalSetup.htmlBottom || '');
                    setPaymentMethods(portalSetup.paymentMethods || []);
                    setPaymentTerms(portalSetup.paymentTerms || []);
                }
                else {
                    setError(`Could not fetch portal setup.`);
                }
            }));
        }
        setMessage('Fetching registration details...');
        fetch(`/api/getPortalInteraction?id=${id}&c=${companyId}`).then((response) => __awaiter(void 0, void 0, void 0, function* () {
            if (response.ok) {
                const responseBody = yield response.json();
                setFormData({
                    name: responseBody.name,
                    address: responseBody.address,
                    address2: responseBody.address2,
                    city: responseBody.city,
                    postCode: responseBody.postCode,
                    phoneNo: responseBody.phoneNo,
                    email: responseBody.email,
                    bankAccountNumber: responseBody.bankAccountNumber,
                    bankBranchNo: responseBody.bankBranchNo,
                    iban: responseBody.iban,
                    companyRegistrationNo: responseBody.companyRegistrationNo,
                    vatRegistrationNo: responseBody.vatRegistrationNo,
                    swiftCode: responseBody.swiftCode,
                    datetimeSubmitted: '',
                    paymentMethod: responseBody.paymentMethod || '',
                    paymentTerms: responseBody.paymentTerms || '',
                    files: []
                });
                setStatus(responseBody.status);
            }
            else {
                setError(`Could not find your registration details.`);
            }
            setMessage('');
        }));
    }, [companyId, id]);
    const handleFormChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'files' && files) {
            const fileArray = Array.from(files);
            const oversizedFiles = fileArray.filter(file => file.size > MAX_FILE_SIZE);
            if (oversizedFiles.length > 0) {
                updateError(`Each file must be smaller than ${MAX_FILE_SIZE / (1024 * 1024)}MB`);
                return;
            }
            else {
                updateError('');
            }
            setFormData(Object.assign(Object.assign({}, formData), { [name]: fileArray }));
        }
        else if (name === 'email') {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(value)) {
                updateError('Invalid email address');
            }
            else {
                updateError('');
            }
            setFormData(Object.assign(Object.assign({}, formData), { [name]: value }));
        }
        else {
            setFormData(Object.assign(Object.assign({}, formData), { [name]: value }));
        }
    };
    const handleSelectionChange = (e) => {
        const { name, value } = e.target;
        setFormData(Object.assign(Object.assign({}, formData), { [name]: value }));
    };
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setSubmitButton({ label: 'Submitting...', disabled: true, class: 'submit-button' });
        //set the datetime submitted in the form data
        formData.datetimeSubmitted = new Date().toISOString();
        //remove the files property from the form data to submit
        const { files } = formData, formDataWithoutFiles = __rest(formData, ["files"]);
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    resolve(reader.result.split(',')[1]); //strip the data url prefix
                };
            });
        }
        const response = yield fetch(`/api/updatePortalInteraction?id=${id}&c=${companyId}`, {
            method: 'POST',
            body: JSON.stringify(formDataWithoutFiles)
        });
        if (response.ok) {
            //add files to the registration
            formData.files.forEach((file) => __awaiter(void 0, void 0, void 0, function* () {
                const response = yield fetch(`/api/addFileToPortalInteraction?id=${id}&c=${companyId}`, {
                    method: 'POST',
                    body: JSON.stringify({
                        fileName: file.name,
                        content: yield getBase64(file)
                    })
                });
                if (!response.ok) {
                    setError(`There was an error adding file ${file.name}' to the registration.`);
                    setSubmitButton({ label: 'Submit', disabled: false, class: 'submit-button' });
                    return;
                }
            }));
            setMessage('Registration submitted successfully');
            setSubmitButton({ label: 'Submitted', disabled: true, class: 'submitted-button' });
        }
        else {
            setError('There was an error submitting the registration.');
            setSubmitButton({ label: 'Submit', disabled: false, class: 'submit-button' });
        }
    });
    return ((0, jsx_runtime_1.jsxs)("div", { className: "App", children: [(0, jsx_runtime_1.jsx)("header", { className: "App-header", style: { backgroundColor: headerColour }, children: (0, jsx_runtime_1.jsx)("h1", { children: headerTitle }) }), (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: htmlTop } }), (0, jsx_runtime_1.jsxs)("main", { children: [(0, jsx_runtime_1.jsxs)("div", { className: 'form-status', children: [message && (0, jsx_runtime_1.jsx)("div", { className: "message", children: message }), error && (0, jsx_runtime_1.jsx)("div", { className: "error", children: error })] }), (0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit, className: "form", children: [(0, jsx_runtime_1.jsxs)("div", { className: 'form-section', children: ["Company Details", (0, jsx_runtime_1.jsx)("hr", {})] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "name", children: "Name: *" }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: "name", name: "name", value: formData.name, onChange: handleFormChange, maxLength: 100, required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-group', children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "companyRegistrationNo", children: "Company Registration No: *" }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: "companyRegistrationNo", name: "companyRegistrationNo", value: formData.companyRegistrationNo, onChange: handleFormChange, maxLength: 20, required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-group', children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "vatRegistrationNo", children: "VAT Registration No: *" }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: "vatRegistrationNo", name: "vatRegistrationNo", value: formData.vatRegistrationNo, onChange: handleFormChange, maxLength: 20, required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-section', children: ["Address Details", (0, jsx_runtime_1.jsx)("hr", {})] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "address", children: "Address: *" }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: "address", name: "address", value: formData.address, onChange: handleFormChange, maxLength: 100, required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "address2", children: "Address 2:" }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: "address2", name: "address2", value: formData.address2, onChange: handleFormChange, maxLength: 50 })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "city", children: "City: *" }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: "city", name: "city", value: formData.city, onChange: handleFormChange, maxLength: 30, required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "postCode", children: "Post Code: *" }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: "postCode", name: "postCode", value: formData.postCode, onChange: handleFormChange, maxLength: 20, required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-group', children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "address", children: "Phone No: *" }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: "phoneNo", name: "phoneNo", value: formData.phoneNo, onChange: handleFormChange, maxLength: 30, required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "email", children: "Email: *" }), (0, jsx_runtime_1.jsx)("input", { type: "email", id: "email", name: "email", value: formData.email, onChange: handleFormChange, pattern: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$', maxLength: 80, required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-section', children: ["Payment Details", (0, jsx_runtime_1.jsx)("hr", {})] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-group', children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: 'paymentMethod', children: "Payment Method:" }), (0, jsx_runtime_1.jsxs)("select", { id: 'paymentMethod', name: 'paymentMethod', value: formData.paymentMethod, onChange: handleSelectionChange, children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: " " }), paymentMethods.map((method) => ((0, jsx_runtime_1.jsx)("option", { value: method.code, children: method.description }, method.code)))] })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-group', children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: 'paymentTerms', children: "Payment Terms:" }), (0, jsx_runtime_1.jsxs)("select", { id: 'paymentTerms', name: 'paymentTerms', value: formData.paymentTerms, onChange: handleSelectionChange, children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: " " }), paymentTerms.map((term) => ((0, jsx_runtime_1.jsx)("option", { value: term.code, children: term.description }, term.code)))] })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-section', children: ["Bank Account Details", (0, jsx_runtime_1.jsx)("hr", {})] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-group', children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: 'bankAccountNumber', children: "Bank Account Number: *" }), (0, jsx_runtime_1.jsx)("input", { type: 'text', id: 'bankAccountNumber', name: 'bankAccountNumber', value: formData.bankAccountNumber, onChange: handleFormChange, maxLength: 30, required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-group', children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: 'bankBranchNo', children: "Sort Code: *" }), (0, jsx_runtime_1.jsx)("input", { type: 'text', id: 'bankBranchNo', name: 'bankBranchNo', value: formData.bankBranchNo, onChange: handleFormChange, maxLength: 20, required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-group', children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: 'swiftCode', children: "SWIFT Code:" }), (0, jsx_runtime_1.jsx)("input", { type: 'text', id: 'swiftCode', name: 'swiftCode', value: formData.swiftCode, onChange: handleFormChange, maxLength: 20 })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'form-group', children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: 'iban', children: "IBAN:" }), (0, jsx_runtime_1.jsx)("input", { type: 'text', id: 'iban', name: 'iban', value: formData.iban, onChange: handleFormChange, maxLength: 50 })] }), (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "files", children: "Upload Files:" }), (0, jsx_runtime_1.jsx)("input", { type: "file", id: "files", name: "files", multiple: true, onChange: handleFormChange })] }), (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: htmlBottom } }), (0, jsx_runtime_1.jsx)("button", { type: "submit", className: submitButton.class, disabled: submitButton.disabled, children: submitButton.label })] })] })] }));
};
exports.default = App;
